import { Paragraph2 } from "@bounce/design-system"

import { StoreCardSection } from "./StoreCardSection"
import { useReservationCountText } from "../hooks/useReservationCountText"
import type { NearbyStorageSpot } from "@/libs/bounce/stores/types"

import RocketIcon from "@bounce/assets/icons/Rocket.svg"

type StoreCardReservationsSectionProps = Pick<
  NearbyStorageSpot,
  "last7dReservationCount" | "last30dReservationCount" | "last365dReservationCount" | "totalReservationCount"
>

export const StoreCardReservationsSection = (reservationCounts: StoreCardReservationsSectionProps) => {
  const { text, totalText } = useReservationCountText(reservationCounts)

  if (!text) {
    return null
  }

  return (
    <StoreCardSection icon={RocketIcon}>
      <Paragraph2 className="!text-[0.875rem]">{text}</Paragraph2>
      {!!totalText && <Paragraph2 className="mt-1 !text-[0.875rem]">{totalText}</Paragraph2>}
    </StoreCardSection>
  )
}
